import moment from "moment";
import _ from "lodash";

import { dateToApiString } from "../../utils/date";

const _initialState = {
  apiFilters: {},
  activeFilters: 0,
  context: "todo",
  endDate: null,
  filters: {
    activity: null,
    account: null,
    productGroup: null,
    opportunity: null
  },
  initialDate: dateToApiString(moment().subtract(60, "days")),
  modalOpen: false,
  sortDir: "desc",
  sortBy: "entryDate",
  startDate: dateToApiString(moment().subtract(30, "days")),
  totalHours: {},
  version: 0,
};

export default function historyFiltersReducer(state = _initialState, action) {
  switch (action.type) {
    case "SET_API_FILTERS":
      return { ...state, apiFilters: action.payload };
    case "SET_HISTORY_ALL_UNTRACKED":
      return setAllUntracked(state, action);
    case "SET_HISTORY_CONTEXT":
      return setHistoryContext(state, action);
    case "SET_HISTORY_FILTERS":
      return setHistoryFilters(state, action);
    case "CLEAR_HISTORY_FILTERS":
      return { ...state, version: state.version+1, activeFilters: 0, filters: { ..._initialState.filters } };
    case "SET_TOTAL_HOURS": {
      const { totalHours } = action;

      return { ...state, totalHours };
    }
    case "SET_INITIAL_DATE":
      return setInitialDate(state, action);
    case "SET_START_DATE" :
      return {
        ...state,
        startDate: action.startDate || state.initialDate,
      };
    case "SET_END_DATE":
      return {
        ...state,
        endDate: action.endDate,
      };
    case "UNSET_START_DATE" :
      return {
        ...state,
        startDate: state.initialDate,
      };
    case "UNSET_END_DATE":
      return {
        ...state,
        endDate: null,
      };
    case "SET_SORT_DIR":
      return { ...state, sortDir: action.sortDir };
    case "HISTORY_FILTER_MODAL_OPEN":
      return { ...state, modalOpen: true };
    case "HISTORY_FILTER_MODAL_CLOSE":
      return { ...state, modalOpen: false };
    case "HISTORY_FILTER_MODAL_TOGGLE":
      return { ...state, modalOpen: !state.modalOpen };
    default:
      return state;
  }
}

function setAllUntracked(state, action) {
  return {
    ...state,
    context: "todo",
    startDate: state.initialDate,
    endDate: null,
  };
}

function setHistoryFilters(state, action) {
  const { filters: currentFilters, version } = state;
  const { filters: newFilters } = action;

  const filters = { ...currentFilters, ...newFilters };

  const activeFilters = countActiveFilters(filters);

  return { ...state, activeFilters, filters, version: version + 1 };
}

function setHistoryContext(state, { name }) {
  return { ...state, context: name };
}

function setInitialDate(state, { initialDate: providedInitialDate }) {
  const initialDate = providedInitialDate || dateToApiString(moment().subtract(60, "days"));

  return { ...state, initialDate, startDate: state.startDate || initialDate };
}

function countActiveFilters(filters) {
  const { active } = _.countBy(filters, function(filter) {
    return _.isPlainObject(filter) ? "active" : "inactive";
  });

  return active || 0;
}



// WEBPACK FOOTER //
// ./app/reducers/history/historyFilters.js